import { Instance } from "../../Base";
import Decorator from "../Decorator";

export default class AbroadConsentDecorator extends Decorator {
  constructor(component: Instance) {
    super(component);

    const abroadConsentCheckbox =
      component.element.querySelector("input");

    if (!abroadConsentCheckbox) return;

    abroadConsentCheckbox.addEventListener("click", (element: any) => {
      const abroadConsentCheckboxes: any = Array.from(document.querySelectorAll("[id^='checkboxAbroadConsent']"));
      if (element.target.checked === true) {
        abroadConsentCheckboxes.forEach((el: any) => {
          if (el.id !== element.target.id) {
            el.checked = false;
          }
        });
      } else {
        abroadConsentCheckboxes.forEach((el: any) => {
          if (el.id === element.target.id) {
            el.checked = false;
          }
        });
      }
    });
  }
}